import {useTheme} from '@mui/material';

export default function ArrowLeftIcon() {
	const theme = useTheme();
	return (
		<svg className="ltr:-scale-100" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path d="M6.37988 3.95337L2.33322 8.00004L6.37988 12.0467"
			      stroke={theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.primary.main}
			      strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M13.6665 8H2.4465"
			      stroke={theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.primary.main}
			      strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
}
